import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDanger = () => {
  return (
    <g>
      <path d="m13.6357 2.3672a7.9653 7.9653 0 1 0 0 11.2705 7.9164 7.9164 0 0 0 0-11.2705zm-1.0605 1.0605a6.4766 6.4766 0 0 1 .497 8.5858l-9.0839-9.0828a6.462 6.462 0 0 1 8.5869.4971zm-9.15 9.1494a6.4766 6.4766 0 0 1 -.4969-8.5858l9.0834 9.0825a6.4791 6.4791 0 0 1 -8.5869-.4967z" />
    </g>
  );
};

export default withIcon(IconDanger);
